import { render, staticRenderFns } from "./FactoryProductLayout.vue?vue&type=template&id=0aaf600a&scoped=true&"
import script from "./FactoryProductLayout.vue?vue&type=script&lang=js&"
export * from "./FactoryProductLayout.vue?vue&type=script&lang=js&"
import style0 from "./FactoryProductLayout.vue?vue&type=style&index=0&id=0aaf600a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaf600a",
  null
  
)

component.options.__file = "FactoryProductLayout.vue"
export default component.exports